import { EditActionDefinition } from '@wix/editor-platform-host-integration-apis';
// import { ACTIONS } from '@wix/component-protocol/schema';

import {
  PlatformContext,
  CustomManifestAction,
  EditActionsDictionary,
} from '../types';
import {
  filterByTags,
  objectFilter,
  resolveCustomActionsWithFactories,
} from '../utils';
import { convertCustomActionToExecutableFactory } from './actionHandlers';

// const customActionsMock: Record<string, CustomManifestAction> = {
//   action1: {
//     hidden: false,
//     displayName: 'custom action',
//     // tags: ['tag1'],
//     execution: {
//       actionType: ACTIONS.ACTION_TYPE.panel,
//       panel: {
//         panelType: ACTIONS.PANEL_TYPE.inline,
//         inline: {
//           contentType: ACTIONS.PANEL_CONTENT_TYPE.url,
//           url: 'https://localhost:3300/assets/frame-demo.html',
//           displayName: 'custom action',
//         },
//       },
//     },
//   },
// };

export const getCustomEditActions = (
  platformContext: PlatformContext,
  tags?: string[],
): EditActionDefinition[] => {
  const { manifestServicesAPI, editorPointer } = platformContext;

  const customActions: EditActionsDictionary<CustomManifestAction> =
    manifestServicesAPI.get.customActions(
      editorPointer,
    ) as EditActionsDictionary<CustomManifestAction>;

  if (!customActions) {
    return [];
  }

  const enabledCustomActions = objectFilter(
    customActions,
    (action) => !action.hidden,
  );

  const customActionsFactories =
    convertCustomActionToExecutableFactory(enabledCustomActions);
  const resolvedCustomActions = resolveCustomActionsWithFactories(
    customActionsFactories,
    enabledCustomActions,
    platformContext,
  );

  return filterByTags(resolvedCustomActions, tags);
};
